var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loading-inside-component"},[_c('div',{staticClass:"loading-bg"},[_vm._v(" ")]),_c('div',{staticClass:"loading-wrap text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }